import React from 'react';
import { Switch, switchClasses, styled, SwitchProps, FormControlLabel, Box } from '@mui/material';

interface TwSwitchProps extends SwitchProps {
  label?: string;
  padding?: string;
}

const StyledSwitch = styled((props: SwitchProps) => <Switch {...props} />)(() => ({
  width: '36px',
  height: '20px',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  [`& .${switchClasses.switchBase}`]: {
    padding: 0,
    margin: 0,
    transform: 'translateX(0)',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      '& + .MuiSwitch-track': {
        backgroundColor: '#3A4DE9',
        opacity: 1
      }
    }
  },
  [`& .${switchClasses.thumb}`]: {
    width: '20px',
    height: '20px',
    borderRadius: '20px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E5E7EB',
    boxShadow: 'none'
  },
  [`& .${switchClasses.track}`]: {
    borderRadius: '8px',
    height: '16px',
    opacity: 1,
    backgroundColor: '#E5E7EB',
    position: 'absolute',
    top: '50%',
    left: 0,
    right: 0,
    transform: 'translateY(-50%)'
  }
}));

const StyledFormControlLabel = styled(FormControlLabel)({
  margin: 0,
  padding: 0,
  minHeight: '36px',
  display: 'flex',
  alignItems: 'center',
  '& .MuiFormControlLabel-label': {
    marginLeft: '12px',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    color: '#374151'
  }
});

const TwSwitch: React.FC<TwSwitchProps> = ({ label, ...props }) => {
  if (!label) {
    return <StyledSwitch {...props} />;
  }

  return <StyledFormControlLabel control={<StyledSwitch {...props} />} label={label} />;
};

export default TwSwitch;
